import React from "react";

// Importing settings components
import TimezoneSettings from "./TimezoneSettings";

const SettingManagement = () => {
  return (
    <section className="section dashboard">
      <TimezoneSettings />
    </section>
  );
};

export default SettingManagement;
